import { createStore } from 'vuex'
import auth from './modules/auth' // Auth modülünü import et
// Diğer modüller buraya eklenecek
// import announcements from './modules/announcements'
// import news from './modules/news'
// import educations from './modules/educations'
// import notifications from './modules/notifications'

export default createStore({
  state: {
    // Global state (gerekirse)
    isLoading: false,
    error: null,
  },
  mutations: {
    // Global mutations
    SET_LOADING(state, payload) {
      state.isLoading = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
      console.error("Global Error:", payload); // Hataları konsolda gör
    },
    CLEAR_ERROR(state) {
      state.error = null;
    }
  },
  actions: {
    // Global actions
  },
  getters: {
    // Global getters
    isLoading: state => state.isLoading,
    error: state => state.error,
  },
  modules: {
    auth, // Auth modülünü ekle
    // announcements,
    // news,
    // educations,
    // notifications,
  }
})